<template>
    <!-- <div class="templete_box">
        <div class="crumbsNav clearfix no_print">
            <div class="navSon navSonChecked" v-if="categoryBoardType">
                在途板材
            </div>
            <div class="navSon" v-if="categoryRawType">
                在途原木
            </div>
            <div class="navSon" v-if="categoryScrapType">
                在途集成材
            </div>
        </div> -->
        <div class="templete">
            <div class="search_box clearfix no_print">
                <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="树种" @visible-change="getSelectWarehouseList('breed_id')">
                    <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.bale_no" placeholder="根号" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.original_length" multiple collapse-tags placeholder="长度" @visible-change="getSelectWarehouseList('original_length')">
                    <el-option v-for="(list,index) in selectMapC.original_length" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.original_thickness" multiple collapse-tags placeholder="直径" @visible-change="getSelectWarehouseList('original_thickness')">
                    <el-option v-for="(list,index) in selectMapC.original_thickness" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" @visible-change="getSelectWarehouseList('supplier_id')">
                    <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="合同号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.batch_no" placeholder="批次号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.ship_no" placeholder="船名" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.heap_no" placeholder="堆号" size="mini"></el-input>
                <!-- <el-select class="search_select search_inputBox" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectWarehouseList('supplier_id')">
                    <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select> -->
                <!-- <el-select class="search_select search_inputBox" v-model="params.grade_id" multiple collapse-tags placeholder="等级" @visible-change="getSelectWarehouseList('grade_id')">
                    <el-option v-for="list in selectMapC.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.bale_no" placeholder="捆包号" size="mini"></el-input> -->
                <!-- <div class="search_time search_inputBox">
                    <el-date-picker v-model="inbound_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="入库时间"></el-date-picker>
                </div> -->
                <!-- <el-select class="search_select search_inputBox" v-model="params.warehouse_id" multiple collapse-tags placeholder="仓库" @visible-change="getSelectWarehouseList('warehouse_id')">
                    <el-option v-for="list in selectMapC.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select> -->
                <!-- <div class="search_time search_inputBox">
                    <el-input v-model="params.price_min" placeholder="价格区间" size="mini"></el-input>
                    ~
                    <el-input v-model="params.price_max" placeholder="价格区间" size="mini"></el-input>
                </div> -->
                <!-- <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.bill_lading_no" placeholder="提单号" size="mini"></el-input> -->
                <!-- <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.remark" placeholder="备注" size="mini"></el-input> -->
                <!-- <el-select class="search_select search_inputBox" v-model="params.port_id" multiple collapse-tags placeholder="目的港">
                    <el-option v-for="list in portList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select> -->
                <!-- <el-input class="search_input search_inputBox" v-model="params.container_no" placeholder="货柜号" size="mini"></el-input> -->
                <div class="searchBtnList clearfix">
                    <!-- <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div> -->
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                </div>
            </div>
            <div class="btnList clearfix no_print">
                <el-button class="funcPublicBtn" v-if="module.indexOf(',purchase-report-road-print,')!=-1" @click="printTip">打印标签</el-button>
                <!-- <el-button class="funcPublicBtn">新增销售单</el-button> -->
                <el-button class="funcPublicBtn" v-if="module.indexOf(',purchase-report-road-update,')!=-1" @click="batchEdit">批量修改</el-button>
                <el-button class="funcPublicBtn" v-if="module.indexOf(',purchase-report-road-delete,')!=-1" @click="batchDel">批量删除</el-button>
                <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.indexOf(',purchase-report-road-instore,')!=-1" @click="confirm">确认入库</el-button>
            </div>
            <div class="tableBox no_print">
                <tabletem :isSetCol="true" scene="stock.wood.transit" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @getTableDelete="getTableDelete" @getTableSee="getTableSee" @getTableEdit="getTableEdit" @rowClick="rowClick"></tabletem>
            </div>
            <div class="totalCal no_print">
                <div class="totalName">合计：</div>
                <div class="totalNumber">选定立方:{{selectTotalCube}}</div>
                <div class="totalNumber">合计件数:{{totalObj.numbers}}</div>
                <div class="totalNumber">合计立方:{{totalObj.cube_total}}</div>
            </div>
            <div class="pageBox no_print">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
            <!-- 修改库存START -->
            <el-dialog v-dialog-drag :visible.sync="dialogVisibleSet" class="eldialog eldialogA" width="630px" :modal="false" title="修正原始码单数据" custom-class="full_dialog">
                <el-form ref="editForm" :model="editForm" class="clearfix">
                    <div class="eldialogFormBox">
                    <el-form-item  label="树种：" prop="breed_id">
                        <el-select v-model="editForm.breed_id" @visible-change="getSelectList('breed')">
                            <el-option v-for="list in selectMap.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="供应商：" prop="supplier_id">
                        <el-select v-model="editForm.supplier_id" @visible-change="getSelectList('supplier')" filterable>
                            <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="根号：" prop="bale_no">
                        <el-input v-model="editForm.bale_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="合同号：" prop="contract_no">
                        <el-input v-model="editForm.contract_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="长度：" prop="original_length">
                        <el-input v-model="editForm.original_length"></el-input>
                    </el-form-item>
                    <el-form-item  label="批次号：" prop="batch_no">
                        <el-input v-model="editForm.batch_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="直径：" prop="original_thickness">
                        <el-input v-model="editForm.original_thickness"></el-input>
                    </el-form-item>
                    <el-form-item  label="船名：">
                        <el-input v-model="editForm.ship_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="码单立方：" prop="original_cube">
                        <el-input v-model="editForm.original_cube"></el-input>
                    </el-form-item>
                    <el-form-item  label="堆号：" prop="heap_no">
                        <el-input v-model="editForm.heap_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="销售单价：" prop="sales_price">
                        <el-input v-model="editForm.sales_price"></el-input>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="editForm.remark"></el-input>
                    </el-form-item>
                    </div>
                </el-form>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn" @click="edit([editForm.id])">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="dialogVisibleSet=!dialogVisibleSet">取消</el-button>
                </div>
            </el-dialog>
            <!-- 修改库存END -->
            <!-- 确认入库START -->
            <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogOneLabel" width="400px" :modal="false" title="入库" custom-class="full_dialog">
                <div class="">
                    <el-form>
                        <el-form-item label="仓库:">
                            <el-select class="edit_input" v-model="outWas.warehouse_id" @visible-change="getSelectList('warehouse')">
                                <el-option v-for="list in selectMap.warehouse" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="时间：">
                            <el-date-picker class="edit_input" v-model="outtime" type="date" size="mini"></el-date-picker>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="dialogBtnList clearfix">
                    <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="outWasFunc">确定</el-button>
                    <el-button class="funcPublicBtn dialogBtn" @click="dialogVisible = false">关闭</el-button>
                </div>
            </el-dialog>
            <!-- 确认入库END -->
            <!-- 字段过滤 START -->
            <filter-fields :tableData="filter" scene="stock.wood.transit" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
            <!-- 字段过滤 END -->
            <!-- 宽度列表START -->
            <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
                <total-widthnew :edit="false" :list="widthList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
            </el-dialog>
            <!-- 宽度列表END -->
            <!-- 标签打印 START -->
            <div class="print">
                <div class="printTipBox" v-for="(list,index) in printTipList" :key="index">
                    <div :class="['tipNameBox',list.category_id==1?'tipNameBoxB':'']">
                        <div class="tipbale_no">{{list.bale_no}}</div>
                        <div class="tipName tipNameA" v-if="list.category_id==1">{{list.breed}}</div>
                        <div class="tipName tipNameB" v-if="list.category_id==2">{{list.thk}}</div>
                    </div>
                    <div :class="['mess','clearfix',list.category_id==1?'messB':'messC']">
                        <img :src="list.qr_code" class="tipImage"/>
                        <div class="tipDetail tipDetailA clearfix" v-if="list.category_id==1">
                            <div class="detail detailbeimei"><span class="detailContentT detailContentTP">THK:</span><span class="detailContent">{{list.thk}}</span></div>
                            <div class="detail detailbeimei"><span class="detailContentT detailContentTP">Grade:</span><span class="detailContent">{{list.grade}}</span></div>
                            <div class="detail detailbeimei"><span class="detailContentT detailContentTP">Length:</span><span class="detailContent">{{list.original_length}}</span></div>
                            <div class="detail detailbeimei"><span class="detailContentT detailContentTP">Brand:</span><span class="detailContent">{{list.brand}}</span></div>
                            <div class="detail detailbeimei"><span class="detailContentT detailContentTP">Contract No:</span><span class="detailContent">{{list.contract_no}}</span></div>
                        </div>
                        <div class="tipDetail tipDetailB clearfix" v-if="list.category_id==2">
                            <div class="detail"><span class="detailContentT">批次:</span><span class="detailContent">{{list.batch_no}}</span></div>
                            <div class="detail"><span class="detailContentT">品名:</span><span class="detailContent">{{list.breed}}</span></div>
                            <div class="detail"><span class="detailContentT">材积:</span><span class="detailContent">{{list.original_cube}}</span></div>
                            <div class="detail"><span class="detailContentT">层数:</span><span class="detailContent">{{list.layer_number}}</span></div>
                            <div class="detail"><span class="detailContentT">合同:</span><span class="detailContent">{{list.contract_no}}</span></div>
                        </div>
                    </div>
                    <!-- <div class="printBottomCB clearfix" v-if="list.category_id==1">
                        <div class="printBottom">
                            <div class="bottomMess">{{list.company_name}}</div>
                            <div class="bottomMess">公司地址：{{list.company_address}}</div>
                            <div class="bottomMess">联系电话：{{list.company_mobile}}</div>
                        </div>
                    </div> -->
                    <div class="printBottomCF clearfix" v-if="list.category_id==2">
                        码单：{{list.width}}
                    </div>
                </div>
            </div>
            <!-- 标签打印 END -->
        </div>
    <!-- </div> -->
</template>
<script>
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
                categoryScrapType:localStorage.dw_erp_category.indexOf("scrap")!=-1?true:false,
                categoryGlulamType:localStorage.dw_erp_category.indexOf("glulam")!=-1?true:false,
                isShowMore:false,
                dialogVisibleWidth:false,
                widthList:[],
                params:{
                    bill_lading_no:"",
                    contract_no:"",
                    batch_no:"",
                    ship_no:"",
                    heap_no:"",
                    breed_id:"",
                    original_length:"",
                    original_thickness:"",
                    lock_status:"",
                    page:1,
                    per_page:50
                },
                last_page:1,
                total:0,
                selectRow:[],
                selectMapC:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    port_id:[],
                    grade_id:[],
                    warehouse_id:[],
                    original_length:[],
                    original_thickness:[]
                },
                selectMap:{
                    port:[],
                    warehouse:[],
                    supplier:[],
                    breed:[],
                    brand:[],
                    grade:[]
                },
                list:[],
                tableCol:[
                    {colName:"资源状态",colKey:"status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"树种",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"根号",colKey:"bale_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"长度",colKey:"original_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"直径",colKey:"original_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"码单立方",colKey:"original_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"挂牌价",colKey:"sales_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商",colKey:"supplier",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"批次号",colKey:"batch_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"船名",colKey:"ship_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"堆号",colKey:"heap_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"预计入库",colKey:"expected_storage_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"预计到港",colKey:"expected_arrival_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"直径",colKey:"original_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"根数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"锁定人",colKey:"locker_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"外币单价",colKey:"foreign_currency_price",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"采购单价",colKey:"cube_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"销售单价",colKey:"sales_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"目的港",colKey:"purpose_port",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"到期日",colKey:"expiry_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                editForm:{
                    id:[],
                    supplier_id:"",
                    breed_id:"",
                    contract_no:"",
                    bale_no:"",
                    batch_no:"",
                    original_length:"",
                    ship_no:"",
                    original_thickness:"",
                    heap_no:"",
                    original_cube:"",
                    sales_price:"",
                    remark:""
                },
                dialogVisibleSet:false,
                dialogVisible:false,
                outWas:{
                    id:[],
                    warehouse_id:"",
                    inbound_time:""
                },
                outtime:new Date(),
                totalObj:{},
                selectTotalCube:0,
                editIds:[],
                editType:2,//修改  2单个修改 3多个修改
                filterDialogVisible:false,
                filter:"",
                fields:"",
                printTipList:[],
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
            this.getSelectList("port")
            this.getSelectList("warehouse")
            this.getSelectList("supplier")
            this.getSelectList("breed")
            this.getSelectList("brand")
            this.getSelectList("grade")
        },
        methods:{
            filterConfirm(){
                this.getList()
            },
            //打印标签
            printTip(){
                if(this.selectRow.length<1){
                    this.tip("请选择打印数据","warning")
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.postFunc("/erp/inventory.print.tag",{id:arr},res=>{
                        this.pl(res);
                        this.printTipList=res.data.data;
                        setTimeout(() => {
                            window.print();
                        }, 0);
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            getSelectWarehouseList(target){
                this.$getSelectWarehouseList(target,this.params,1).then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            batchEdit(){
                if(this.selectRow.length<1){
                    this.tip("请选择库存","warning")
                }else{
                    let flag = true;
                    this.editIds=[];
                    for(let i=0;i<this.selectRow.length;i++){
                        if(!this.selectRow[i].isEdit){
                            flag = false;
                            this.tip("选择商品中有不可修改项","warning")
                            return;
                        }else{
                            this.editIds.push(this.selectRow[i].id)
                        }
                    }
                    if(flag){
                        this.editType=3;
                        this.dialogVisibleSet=true;
                    }
                }
            },
            edit(){
                if(this.editType==3){
                    this.editForm.id=this.editIds;
                }
                let url = "";
                if(this.editType==2){
                    url = "/erp/stock.wood.update.one";
                }else{
                    url = "/erp/stock.wood.update";
                }
                let inbound_time = this.editForm.inbound_time;
                let expected_arrival_time = this.editForm.expected_arrival_time;
                let expected_storage_time = this.editForm.expected_storage_time;
                this.editForm.inbound_time=this.formatTimeZero(this.editForm.inbound_time)
                this.editForm.expected_arrival_time=this.formatTimeZero(this.editForm.expected_arrival_time)
                this.editForm.expected_storage_time=this.formatTimeZero(this.editForm.expected_storage_time)
                this.postFuncLoading(url,this.editForm,()=>{
                    this.tip('修改成功','success');
                    this.dialogVisibleSet=false;
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                    this.editForm.inbound_time = inbound_time;
                    this.editForm.expected_arrival_time = expected_arrival_time;
                    this.editForm.expected_storage_time = expected_storage_time;
                },()=>{
                    this.editForm.inbound_time = inbound_time;
                    this.editForm.expected_arrival_time = expected_arrival_time;
                    this.editForm.expected_storage_time = expected_storage_time;
                })
            },
            batchDel(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    let arr = new Array();
                    for(let i=0;i<this.selectRow.length;i++){
                        if(this.selectRow[i].isDelete){
                            arr.push(this.selectRow[i].id)
                        }else{
                            this.tip("请选择数据有不可删除项","warning")
                            return;
                        }
                    }
                    this.del(arr)
                }
            },
            del(ids){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/inventory.delete",{id:ids},()=>{
                        this.tip('删除成功','success');
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            outWasFunc(){
                this.$confirm('是否确认入库?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.outWas.id=arr;
                    this.outWas.inbound_time=this.formatTimeZero(this.outtime);
                    this.postFuncLoading("/erp/inventory.inbound",this.outWas,()=>{
                        this.tip('入库成功','success');
                        this.dialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            confirm(){
                if(this.selectRow.length<1){
                    this.tip("请选择商品","warning")
                }else{
                    this.dialogVisible=true;
                }
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.$postColumnList("/erp/stock.wood.transit",this.params,res=>{
                    this.last_page=parseInt(res.data.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.totalObj=res.data.data.total;
                    this.totalObj.cube_total=this.keepLimit(this.totalObj.cube_total)
                    this.list=res.data.data.data.data;
                    this.list.forEach((item,index)=>{
                        if(item.expected_arrival_time!=0){
                            this.list[index].expected_arrival_time = this.formatTime(item.expected_arrival_time+"000")
                        }else{
                            this.list[index].expected_arrival_time = "";
                        }
                        if(item.actual_arrival_time!=0){
                            this.list[index].actual_arrival_time = this.formatTime(item.actual_arrival_time+"000")
                        }else{
                            this.list[index].actual_arrival_time = "";
                        }
                        if(item.expected_storage_time!=0){
                            this.list[index].expected_storage_time = this.formatTime(item.expected_storage_time+"000")
                        }else{
                            this.list[index].expected_storage_time = "";
                        }
                        if(item.expiry_time!=0){
                            this.list[index].expiry_time = this.formatTime(item.expiry_time+"000")
                        }else{
                            this.list[index].expiry_time = "";
                        }
                        this.list[index].thickness = this.keepLimit(item.thickness)
                        this.list[index].length = this.keepLimit(item.length)
                        // this.list[index].original_width_total = parseInt(item.original_width_total)
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                if(obj.name=="original_width_total"){
                    this.list.forEach(item=>{
                        if(item.id==obj.id){
                            this.widthList = item.width;
                            this.dialogVisibleWidth = true;
                        }
                    })
                }
            },
            getTableDelete(id){
                this.del([id])
            },
            getTableSee(id){
                this.pl(id)
            },
            getTableEdit(id){
                this.list.forEach(item=>{
                    if(item.id==id){
                        this.editForm=JSON.parse(JSON.stringify(item));
                        this.editForm = this.clearZero(this.editForm)
                        // let arr = new Array();
                        // arr[0]=item.id;
                        this.editForm.id=item.id;
                    }
                })
                this.dialogVisibleSet=true;
            },
            getRow(row){
                this.selectRow=row;
                let total=0;
                this.selectRow.forEach(item=>{
                    total+=parseFloat(item.original_cube)
                })
                this.selectTotalCube=this.keepLimit(total);
            }
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "dialogVisible":function(){},
            "dialogVisibleSet":function(val){
                if(!val){
                    this.editForm=this.resetJson(this.editForm);
                    this.editIds=[];
                    this.editType=2
                }
            },
        }
    }
</script>
<style scoped>
    .print{color:#000;}
    .print .printTipBox{background-color: #fff;position: relative;display: inline-block;width:14.25cm;height:9.5cm;border-bottom:1px dotted #ccc;}
    .print .tipNameBox{text-align: center;padding-bottom:5px;}
    .print .tipNameBoxB{border-bottom:2px solid #000;}
    .print .tipbale_no{font-size: 75px;font-weight: 600;font-family: fantasy;}
    .print .tipNameA{font-size: 30px;font-weight: 600;}
    .print .tipNameB{font-size: 45px;font-weight: 600;}
    .print .printTipBox .mess{position: relative;padding:8px 0;padding-right:180px;box-sizing: border-box;}
    .print .printTipBox .messB{border-bottom:2px solid #000;padding:0px 0;padding-right:180px;}
    .print .printTipBox .messC{padding:0px 0;padding-right:180px;margin-top:10px;}
    .print .tipImage{width:155px;height:155px;position: absolute;top:0px;right:10px;bottom:0;margin:auto;}
    /* .print .tipDetail{} */
    .print .detail{min-width: 40%; height:41px;text-align: left;font-size: 28px;margin-bottom:10px;padding-left:10px;box-sizing: border-box;margin-right:35px;}
    .print .detail:nth-child(2n){margin-right: 0;}
    .print .detail .detailContent{font-weight: 600;}
    .print .tipDetailA .detail{margin-bottom:25px;float: left;}
    .print .tipDetailB .detail{float:left;}
    .print .tipDetailB .detailA{width:100%;}
    .print .tipDetail .detail:last-child{margin-bottom:0;}
    .printBottomCB{text-align: right;padding:0 10px;margin-top:5px;}
    .printBottomCB .printBottom{display: inline-block;text-align: left;}
    .printBottomCB .bottomMess{font-size: 12px;padding:1px 0;}
    .printBottomCF{padding:0 10px;margin-top:5px;font-size: 12px;text-align: left;}
    .detailContentT{font-size: 12px;}
    .print .detailbeimei{height: 35px!important;position: relative;padding-left:50px;box-sizing: border-box;}
    .print .detailContentTP{position: absolute;width:50px;text-align: right;top:50%;transform: rotateY(-50%);left:0;}
</style>
